import React,{ Component } from 'react';
import $ from 'jquery';
import {Link} from 'react-router';
const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';
export default class PromoOfr_Details extends Component{
	constructor(props){
		super(props);
		this.state={
			title: '',
			description: '',
			terms: '',
			enddate:'',
			discount_type: '',
			image: '',
			details: [],
			share_title: '',
			share_desc: '',
			share_panel_open: false,
		};
	}
	componentDidMount()
	{
		if(screen.width >= 800)
		{
			window.location.href='/web/offer/'+this.props.params.Oid+'/details';
		}
		if(!localStorage.token && !localStorage.user_id)
		{
			localStorage.setItem('pro_ofr_dtls','/offer/'+this.props.params.Oid+"/details");
		}
		var data1={from:'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),ofr_id:this.props.params.Oid}
		var data2=JSON.stringify(data1);
		$.ajax({
				method:'post',
				url: baseUrl+"get_promo_ofr",
				dataType: 'json',
				data: {req:data2},
				success: function(data){
					var details=$.makeArray(data.data);
			
					this.setState({
						details: details,
						title: details[0].title,
						image: details[0].image,
						description: details[0].description,
						terms: details[0].terms,
						enddate:details[0].endDate,
						discount_type: details[0].discount_type,
						share_panel_open: false,
					});
				}.bind(this),
				error:function(err){
		
				}
			});
	}
	render()
	{
		document.title=this.state.title ? this.state.title+' | AquaDeals' : 'Offer Details | AquaDeals';
		return(
			<div className="mob_deals ofr_full_details_page">
				<div className="page_hdr">
					<div className="container-fluid">
						<h5><Link to={"/"}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link>{this.state.title ? this.state.title : 'Offer Details'}</h5>
						<a href="/" className="home_newicon"><img src={baseAssets+'mob-assets/home1.png'} alt="Home" /></a>
					</div>
				</div>
				<div className="clr">&nbsp;</div>
				<section className="container" style={{marginTop:'10px'}}>
					<div className="row lst_img">
						<img src={baseAssets+'images/promo_offers/'+this.state.image} alt="" />
					</div>
					<div className="row">
						<div className="col-md-12 col-sm-12 col-xs-12">
							<h4 className="ofr_title">{this.state.title}</h4>
							<table className="table">
								<tr>
									<th>Applicable On</th>
									<th>Offer valid till</th>
								</tr>
								<tr>
									<td>{this.state.discount_type}</td>
									<td>{this.state.enddate !=='' ? this.state.enddate : 'Limited period offer'}</td>
								</tr>
							</table>
						</div>
					</div>
				</section>
				<section className="container" style={{marginTop:'8px'}}>
						<h4>Description</h4>
						<p className="ofr_desc">{this.state.description}</p>
				</section>
				
				<section className="container-fluid" style={{marginTop:'8px'}}>
					<h4>Terms & Conditions</h4>
					<div className="modal_ofr_terms" dangerouslySetInnerHTML={{__html: this.state.terms}}></div>
				</section>
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Common/promo_offers_fulldetails.js
 **/